import { render, staticRenderFns } from "./FacebookCommentsSideNav.vue?vue&type=template&id=940f5aca&"
import script from "./FacebookCommentsSideNav.vue?vue&type=script&lang=js&"
export * from "./FacebookCommentsSideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports